module.exports = __webpack_public_path__ + "static/media/tesla-terraformer-europa-station.6d046ec7.jpg";